import React from 'react';

const TqrAlert = () => {
  return (
    <div style={{ fontSize: "2rem" }}>
      Congratulations! You’ve been selected as a candidate for promotion to transcript quality rating.
      <br />
      <br />
      Please reach out to Arlen (on slack or arlen@qa-world.com) and we’ll get you onboarded as soon as possible.
      <br />
      <br />
      After you complete onboarding, your account will be back to normal and you’ll have the ability to work on both transcription and TQR and will be able to make more money and have more available work!
    </div>
  );
}

export default TqrAlert;
